
class FakeSelect extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = `
      <style id="base-styles">
        .fake-select {
          display: block;
          padding: 10px 12px;
          cursor: pointer;
          display: flex; 
          align-items: center;
          gap: 16px;
          font-size: 14px;
          font-family:"elza-text";
        }
        .swatch {
          display: block;
          width: 16px;
          height: 16px;
          min-width: 16px;
          min-height: 16px;
          border: 1px solid var(--dark-grey);
        }
        .options {
          display: none;
          position: absolute;
          top: calc(100% + 8px);
          left: 0;
          border: 1px solid var(--dark-grey);
          background: white;
          width: calc(100% - 2px);
          max-height: 320px;
          overflow: scroll;
          box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
        }
        .options.open {
          display: block;
          z-index: 10;
        }
        .option {
          padding: 10px 12px;
          cursor: pointer;
          display: flex; 
          align-items: center;
          gap: 16px;
          font-size: 14px;
          background: var(--white);
        }
        .option:hover {
          background: var(--dark-grey);
          color: var(--white);
        }
        select {
          display: none;
        }
        .icon{
          pointer-events: none; 
          position: absolute; 
          right: 0.75rem; 
          top: 50%; 
          display: flex; 
          height: 1rem; 
          width: 1rem; 
          transform: translate(0, -50%);
          align-items: center; 
          justify-content: center; 
          transition-property: all; 
          transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1); 
          transition-duration: 100ms;
        }
        .icon.open{
          transform: translate(0, -50%) rotate(90deg);
        }
      </style>
      <style id="custom-styles"></style>
      <span class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 11 19" fill="none">
          <path d="M1 17.5L9 9.5L1 1.5" stroke="currentColor" stroke-width="2"/>
        </svg>
      </span>
      <div class="fake-select"></div>
      <div class="options"></div>
      <slot></slot>
    `;

    this.fakeSelect = this.shadowRoot.querySelector('.fake-select');
    this.optionsContainer = this.shadowRoot.querySelector('.options');
    this.icon = this.shadowRoot.querySelector('.icon');
    this.customStyles = this.shadowRoot.querySelector('#custom-styles');
  }

  static get observedAttributes() {
    return ['data-css'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-css') {
      this.applyCustomStyles();
    }
  }

  applyCustomStyles() {
    const customCSS = this.getAttribute('data-css') || '';
    this.customStyles.textContent = customCSS;
  }

  connectedCallback() {
    const realSelect = this.querySelector('select');
    if (!realSelect) {
      console.error('FakeSelect must wrap a real <select> element.');
      return;
    }

    //apply custom css
    this.applyCustomStyles();

    // Initialize the fake select with the real select's options.
    this._initializeOptions(realSelect);

    // Show options on fake select click.
    this.fakeSelect.addEventListener('click', () => {
      this.optionsContainer.classList.toggle('open');
      this.icon.classList.toggle('open');
    });

    // Close dropdown when clicking outside.
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.optionsContainer.classList.remove('open');
        this.icon.classList.remove('open');
      }
    });

    // Sync fake UI if real select is changed externally
    realSelect.addEventListener('change', () => {
      const selected = realSelect.options[realSelect.selectedIndex];
      this.fakeSelect.innerHTML = `${selected.dataset.swatch ? `<img class="swatch" width="52" height="52" src="${selected.dataset.swatch}">` : ''} ${selected.textContent}`;
    });
  }


  _initializeOptions(realSelect) {
  // Set the initial display value to the real select's selected option.
  const initialValue = realSelect.options[realSelect.selectedIndex];
  this.fakeSelect.innerHTML = `${initialValue.dataset.swatch ? `<img class="swatch" width="52" height="52" src="${initialValue.dataset.swatch}">` : ''} ${initialValue.textContent}`;

  // Populate the options dropdown.
  Array.from(realSelect.options).forEach((option) => {
    const swatch = option.dataset.swatch;
    const redirect = option.dataset.redirect;
    const fakeOption = document.createElement('div');
    fakeOption.classList.add('option');
    fakeOption.innerHTML = `${swatch ? `<img class="swatch" width="52" height="52" src="${swatch}">` : ''} ${option.textContent}`;
    fakeOption.dataset.value = option.value;

    fakeOption.addEventListener('click', () => {
      if (redirect) {
        window.location.href = redirect;
        return;
      }

      this.fakeSelect.innerHTML = `${swatch ? `<img class="swatch" width="52" height="52" src="${swatch}">` : ''} ${option.textContent}`;
      realSelect.value = option.value;
      realSelect.dispatchEvent(new Event('change', { bubbles: true }));
      this.optionsContainer.classList.remove('open');
      this.icon.classList.remove('open');
    });

    this.optionsContainer.appendChild(fakeOption);
  });
}
}

// Define the custom element.
customElements.define('fake-select', FakeSelect);
